<template>
  <v-layout row>
    <v-flex 
      sm12 
      md8 
      offset-md2
      xl6
      offset-xl3>
      <v-card v-if="unit.code">
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title><strong v-html="unit.code + ':'"/> {{ unit.name }}</v-toolbar-title>
          <unitForm 
            v-if="unit['.key']" 
            :edititem="unit"/>
        </v-toolbar>
        <v-card-text>
          <table>
            <tr>
              <th class="text-xs-left">Name:</th>
              <td>{{ unit.name }}</td>
            </tr>
            <tr>
              <th class="text-xs-left">Created:</th>
              <td>{{ unit.createdUser }}: {{ unit.createdDate.seconds | moment("LLLL") }}</td>
            </tr>
            <tr>
              <th class="text-xs-left">Updated:</th>
              <td>{{ unit.updateUser }}: {{ unit.updateDate.seconds | moment("LLLL") }}</td>
            </tr>
          </table>
          <p>Use <v-icon>drag_handle</v-icon> (drag and drop icon) to re-order the list.</p> 
        </v-card-text>
      </v-card>
      <agreements/>
      <steps/>   

    </v-flex>
  </v-layout>
</template>

<script>
import adminComponents from "@/components/admin";

export default {
  name: "Unit",
  components: {
    ...adminComponents
  },
  data: () => ({
    unit: null
  }),
  firestore() {
    return {
      unit: this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .doc(this.$route.params.unit)
    };
  }
};
</script>
